import {
	Scene,
	Vector3,
	Color4,
	ParticleSystem,
	Texture,
	AbstractMesh,
} from "@babylonjs/core";

function flareTexture(scene: Scene) {
	// Inline 1x1 white PNG used as a soft particle texture. Babylon scales it.
	const tex = new Texture(
		"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgAAIAAAUAAen63NgAAAAASUVORK5CYII=",
		scene,
	);
	tex.hasAlpha = true;
	return tex;
}

/** Confetti-style burst at a world position. */
export function spawnConfetti(scene: Scene, pos: Vector3) {
	const ps = new ParticleSystem("confetti", 240, scene);
	ps.particleTexture = flareTexture(scene);
	ps.emitter = pos.clone();
	ps.minEmitBox = new Vector3(-0.2, 0, -0.2);
	ps.maxEmitBox = new Vector3(0.2, 0, 0.2);
	ps.color1 = new Color4(0.4, 1.0, 0.4, 1);
	ps.color2 = new Color4(1.0, 0.85, 0.3, 1);
	ps.colorDead = new Color4(0.2, 0.4, 0.1, 0);
	ps.minSize = 0.05;
	ps.maxSize = 0.15;
	ps.minLifeTime = 1.0;
	ps.maxLifeTime = 1.8;
	ps.emitRate = 600;
	ps.gravity = new Vector3(0, -3.5, 0);
	ps.direction1 = new Vector3(-2, 6, -2);
	ps.direction2 = new Vector3(2, 9, 2);
	ps.minEmitPower = 0.8;
	ps.maxEmitPower = 2.0;
	ps.updateSpeed = 0.015;
	ps.targetStopDuration = 0.35;
	ps.disposeOnStop = true;
	ps.start();
}

/** Spark burst (red/orange) for printer failures. */
export function spawnSparks(scene: Scene, anchor: AbstractMesh) {
	const ps = new ParticleSystem("sparks", 80, scene);
	ps.particleTexture = flareTexture(scene);
	ps.emitter = anchor;
	ps.minEmitBox = new Vector3(-0.1, 0.5, -0.1);
	ps.maxEmitBox = new Vector3(0.1, 0.7, 0.1);
	ps.color1 = new Color4(1.0, 0.5, 0.1, 1);
	ps.color2 = new Color4(1.0, 0.8, 0.2, 1);
	ps.colorDead = new Color4(0.3, 0, 0, 0);
	ps.minSize = 0.03;
	ps.maxSize = 0.08;
	ps.minLifeTime = 0.4;
	ps.maxLifeTime = 0.8;
	ps.emitRate = 400;
	ps.gravity = new Vector3(0, -2, 0);
	ps.direction1 = new Vector3(-1.5, 1, -1.5);
	ps.direction2 = new Vector3(1.5, 3, 1.5);
	ps.minEmitPower = 0.5;
	ps.maxEmitPower = 1.5;
	ps.updateSpeed = 0.012;
	ps.targetStopDuration = 0.25;
	ps.disposeOnStop = true;
	ps.start();
}
